import { BuildHTML } from "~/components/BuildHtml/BuildHtml";
import {
  eyebrowColorStyle,
  primaryTextColorStyle,
  secondaryTextColorStyle,
} from "~/landing-pages/shared-landing-page-styles";
import { tagToClassNameMap } from "~/landing-pages/utils/tagToClassNameMap";
import { Body, Headline } from "~/ui-library";

export type FeatureHeaderProps = {
  appearance: "dark" | "light";
  description?: string;
  eyebrow?: string;
  title: string;
};

export const FeatureHeader: React.FC<FeatureHeaderProps> = ({
  appearance,
  description,
  eyebrow,
  title,
}) => (
  <div className="lg:mx-auto lg:max-w-2xl lg:text-center">
    {eyebrow ? (
      <Headline
        as="h2"
        data-testid="eyebrow"
        level={6}
        className={eyebrowColorStyle({ appearance, className: "mb-2" })}
      >
        {eyebrow}
      </Headline>
    ) : null}
    <Headline
      as={eyebrow ? "h3" : "h2"}
      level={2}
      className={primaryTextColorStyle({ appearance })}
    >
      {title}
    </Headline>
    {description ? (
      <Body
        className={secondaryTextColorStyle({
          appearance,
          className: "mb-l mt-m",
        })}
        data-testid="body-description"
      >
        <BuildHTML html={description} tagToClassNameMap={tagToClassNameMap} />
      </Body>
    ) : null}
  </div>
);
